<template>
  <vx-card :title="title">
    <div v-show="visibleRes">
      <Actions
        class="mb-5"
        @closeReport="closeReport"
        @downloadPdf="downloadPdf"
      />
      <template v-if="result.length">
        <div ref="contentPdf">
          <a-table :dataSource="result" :columns="columns" :pagination="false" >
            <template slot="footer">
              <div v-if="result.length" class="grid grid-cols-5">
                <div class="font-bold">Total</div>
                <div class="place-self-center mr-18">{{ sumCol(result,'complete').slice(0, -3) }}</div>
                <div class="place-self-center mr-20">{{ sumCol(result,'in_progress').slice(0, -3) }}</div>
                <div class="place-self-start ml-20">{{ sumCol(result,'overdue').slice(0, -3) }}</div>
                <div class="place-self-start ml-10">{{ sumCol(result,'upcoming').slice(0, -3) }}</div>
              </div>
            </template>
          </a-table>
        </div>
      </template>
      <template v-else>
        <a-empty/>
      </template>
    </div>
    <div v-show="!visibleRes">
      <a-form :form="form" @submit.prevent="handleReport">
        <div class="grid grid-cols-1 w-full md:w-1/2">
          <SelectOption
            url="/account/list/"
            label="User"
            field="user"
            :required="false"
            method="get"
            placeholder="Find A User"
            mode="multiple"
            class="w-full self-end"
          />
          <div class="flex flex-col md:flex-row">
            <selectSearch
              :required="false"
              url="/matter/query/"
              :options="optionSearchMatter"
              class="self-end mt-8 md:mt-0 w-full"
              :is_include_matter="true"
              @selectSearch="handleSearch"
            />
          </div>
          <DateRangeComponent :dateForm="form" class="mt-5"/>
        </div>
        <BtnSubmitReport
          ref="reportSubmit"
          @backPage="$emit('changeTab','TaskReport')"
        />
      </a-form>
    </div>
    <ExportPdf
      ref="exportPdf"
      :title="title"
      :pdfForm="form.getFieldsValue(['from_date','to_date'])"
      @onProgress="onProgress"
      @hasDownloaded="hasDownloaded"
    >
      <div id="pdf"></div>
    </ExportPdf>
  </vx-card>
</template>

<script>
import DateRangeComponent from "@/components/date/DateRangeComponent";
import mixin from '../../mixin/mixin'
import SelectOption from "@/views/forms/SelectOptionSingle";
import SelectSearch from "@/views/forms/selectSearch";
import axios from "@/axios";
import BtnSubmitReport from "@/components/btn-report-submit/BtnSubmitReport";
import Actions from "@/components/closeDownloadReport/Actions";
import ExportPdf from "@/components/pdf/ExportPdf";

const columns = [
  {
    title: 'User',
    dataIndex: 'assigned_user',
    key: '1',
  },
  {
    title: 'Complete',
    dataIndex: 'complete',
    key: '2',
  },
  {
    title: 'Progress',
    dataIndex: 'in_progress',
    key: '3',
  },
  {
    title: 'Overdue',
    dataIndex: 'overdue',
    key: '4',
  },
  {
    title: 'Upcoming',
    dataIndex: 'upcoming',
    key: '5',
  },
]

export default {
  name: "ComponentProductivityByUser",
  components: {Actions, BtnSubmitReport, SelectSearch, SelectOption, DateRangeComponent,ExportPdf},
  mixins: [mixin],
  data(){
    return {
      columns,
      title:'Task Productivity'
    }
  },
  methods: {
    handleReport() {
      this.form.validateFields(async (err, values) => {
        if (!err) {
          try {
            this.$refs.reportSubmit.loading = true
            const query = []
            if (values.matter) query.push({field: 'matter', condition: '=', value: values.matter, operation: 'and'})
            if (values.user && values.user.length) query.push({field: 'assigned_user__id', condition: 'in', value: values.user, operation: 'and'})
            if (values.from_date && values.to_date) query.push({ field:'created_at', condition: '>=', value: values.from_date },{ field:'created_at', condition: '<=', value: values.to_date })
            const {data}    = await axios.post('task/report/productivity', { query: query.length ? query : undefined })
            this.visibleRes = true
            this.result     = Object.values(data)
          } catch (e) {
            this.visibleRes = false
            this.$message.error('Server Error')
            throw new Error(e)
          } finally {
            this.$refs.reportSubmit.loading = false
          }
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
